import { Component, EventEmitter, Input, Output } from '@angular/core';

import { B3_WITHDRAWAL_TRANSFER_REASON } from '../shared/operation-b3-withdrawal-transfer-details.utils';

@Component({
  standalone: false,
  selector: 'app-operation-b3-withdrawal-transfer-details-drawer',
  templateUrl: './operation-b3-withdrawal-transfer-details-drawer.component.html',
  styleUrls: ['./operation-b3-withdrawal-transfer-details-drawer.component.scss'],
})
export class OperationB3WithdrawalTransferDetailsDrawerComponent {
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();

  readonly withdrawalReason = B3_WITHDRAWAL_TRANSFER_REASON;

  close(): void {
    this.open = false;
    this.openChange.emit(false);
  }
}
